<template>
  <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
    <defs>
      <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
    </defs>
    <g class="parallax">
      <!-- <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(240,239,237,0.7"></use>
      <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(240,239,237,0.5)"></use>
      <use xlink:href="#gentle-wave" x="48" y="10" fill="rgba(240,239,237,0.3)"></use> -->
      <use xlink:href="#gentle-wave" x="48" y="15" fill="rgba(240,239,237,1)"></use>
      <!-- <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(240,0,237,0.1"></use>
      <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(0,239,237,0.1)"></use>
      <use xlink:href="#gentle-wave" x="48" y="10" fill="rgba(240,239,0,0.1)"></use>
      <use xlink:href="#gentle-wave" x="48" y="15" fill="rgba(240,239,237,1)"></use> -->
    </g>
  </svg>
</template>

<script>
export default {
  
}
</script>

<style lang="stylus" scoped>
.waves
  position absolute
  left 0
  bottom 250px
  width 100%
  height 35vh
  min-height 130px
  max-height 180px
  transform-origin center center 
  transform rotate(180deg)
  .parallax
    use 
      animation moveForever 5s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite

@keyframes moveForever
  0%
    transform translate3d(-90px, 0, 0)
  100% 
    transform translate3d(85px, 0, 0)
</style>